"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = FolderBreadcrumb;

var _FolderBreadcrumb = require("@adobe/react-spectrum-ui/dist/FolderBreadcrumb");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function FolderBreadcrumb(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_FolderBreadcrumb.FolderBreadcrumb, null));
}